import React, { createContext, useContext, useEffect, useState } from "react";

const TRANSLATIONS = {
  fr: {
    "nav.home": "Accueil",
    "nav.services": "Services",
    "nav.gallery": "Galerie",
    "nav.about": "À propos",
    "nav.contact": "Contact",
    "nav.quote": "Obtenir une soumission",
    "nav.admin": "Admin",

    "hero.eyebrow": "Entreprise familiale · Laval, Québec",
    "hero.title.a": "Un nettoyage",
    "hero.title.b": "sur mesure,",
    "hero.title.c": "livré avec soin.",
    "hero.subtitle": "Une famille dévouée, spécialisée dans le nettoyage après construction et l'entretien ménager commercial et industriel.",
    "hero.cta_primary": "Demander une soumission",
    "hero.cta_secondary": "Voir nos services",

    "marquee": "Entretien ménager commercial · Nettoyage après construction · Réparation informatique · Service industriel · Laval · Montréal · Rive-Nord · Rive-Sud",

    "services.eyebrow": "Nos services",
    "services.title": "Nos services",

    // Maintenance detail page
    "maint.hero.eyebrow": "Service — Maintenance",
    "maint.hero.title": "Maintenance",
    "maint.hero.subtitle": "Trois univers, un même standard : industriel, commercial et résidentiel.",
    "maint.types.title": "Différents types de maintenance",

    "maint.industriel.title": "Industriel",
    "maint.industriel.f1": "Nettoyage des entrepôts et usines",
    "maint.industriel.f2": "Nettoyage des surfaces et planchers",
    "maint.industriel.f3": "Entretien des zones communes et sanitaires",
    "maint.industriel.f4": "Service complémentaire : nettoyage après construction",
    "maint.industriel.f5": "Enlèvement des ordures",
    "maint.industriel.goal": "Objectif : améliorer l'hygiène et la productivité de vos employés.",

    "maint.commercial.title": "Commercial",
    "maint.commercial.f1": "Nettoyage des bureaux et espaces de travail",
    "maint.commercial.f2": "Désinfection des surfaces fréquemment touchées",
    "maint.commercial.f3": "Entretien des toilettes",
    "maint.commercial.f4": "Nettoyage des planchers (balayage, lavage)",
    "maint.commercial.f5": "Enlèvement des ordures",
    "maint.commercial.goal": "Résultat : une image professionnelle irréprochable et un espace sain au quotidien.",

    "maint.residentiel.title": "Résidentiel",
    "maint.residentiel.f1": "Nettoyage général des pièces",
    "maint.residentiel.f2": "Entretien des salles de bain",
    "maint.residentiel.f3": "Dépoussiérage et lavage des surfaces",
    "maint.residentiel.f4": "Nettoyage des planchers",
    "maint.residentiel.f5": "Services ponctuels",
    "maint.residentiel.f6": "Services complémentaires : déménagement / aménagement (nettoyage), lavage des vitres et fenêtres",
    "maint.residentiel.goal": "Avantage : plus de temps pour vous, dans un environnement propre et confortable.",

    "maint.plans.title": "Nos abonnements",
    "maint.plans.subtitle": "Certains types de maintenance fonctionnent avec des abonnements. Ceci détermine le nombre de passages par semaine pour réaliser les tâches et ce qui peut être inclus.",
    "maint.plans.per_week": "Passages / semaine",
    "maint.plans.includes": "Inclus",

    "maint.plans.silver.name": "ARGENT",
    "maint.plans.silver.freq": "1",
    "maint.plans.silver.inc": "Nettoyage de base, produit non fourni.",

    "maint.plans.gold.name": "GOLD",
    "maint.plans.gold.freq": "2",
    "maint.plans.gold.inc": "Nettoyage avec produit naturel fourni (balais, vadrouille, vidage de poubelles, toilettes).",

    "maint.plans.premium.name": "PREMIUM",
    "maint.plans.premium.freq": "3",
    "maint.plans.premium.inc": "Nettoyage total — personnalisé + produits naturels fournis (sent-bon, savons, sacs poubelles).",

    "maint.details.title": "Détails des services",
    "maint.details.subtitle": "Services complémentaires disponibles à la carte.",
    "maint.details.item1.title": "Déménagement / aménagement",
    "maint.details.item1.desc": "Nettoyage complet avant l'arrivée ou après le départ des occupants — sols, cuisines, salles de bain, dépoussiérage général.",
    "maint.details.item2.title": "Lavage des vitres et fenêtres",
    "maint.details.item2.desc": "Nettoyage intérieur et extérieur des vitres et fenêtres accessibles, cadrages et rebords accessibles. Résidentiel et commercial. Nous intervenons uniquement sur des fenêtres accessibles.",
    "maint.details.item3.title": "Nettoyage après construction",
    "maint.details.item3.desc": "Nettoyage complet des surfaces et dépoussiérage en profondeur — sols, murs, moulures. Enlèvement de la poussière fine laissée par les travaux, pour une remise des lieux impeccable.",

    // Informatique detail page
    "info.hero.eyebrow": "Service — Informatique",
    "info.hero.title": "Informatique",
    "info.hero.subtitle": "Diagnostic, réparation et support pour vos ordinateurs, portables, réseaux et périphériques. Un service humain, précis, local.",

    "info.pillars.title": "Nos interventions",
    "info.pillar1.title": "Diagnostic complet",
    "info.pillar1.desc": "Analyse matériel et logiciel de votre appareil, identification claire du problème et estimation transparente avant toute réparation.",
    "info.pillar2.title": "Réparation matérielle",
    "info.pillar2.desc": "Remplacement d'écrans, claviers, batteries, disques durs, SSD, ventilateurs, alimentation et composants internes.",
    "info.pillar3.title": "Optimisation & logiciel",
    "info.pillar3.desc": "Installation de systèmes d'exploitation, nettoyage de virus et logiciels malveillants, sauvegarde et récupération de données.",
    "info.pillar4.title": "Installation & réseau",
    "info.pillar4.desc": "Configuration Wi-Fi, imprimantes, périphériques, mise en place de réseau domestique ou de petit bureau.",
    "info.pillar5.title": "Support à distance ou sur site",
    "info.pillar5.desc": "Assistance rapide à distance quand c'est possible, déplacement à Laval ou dans le Grand Montréal quand c'est nécessaire.",
    "info.pillar6.title": "Entretien préventif",
    "info.pillar6.desc": "Dépoussiérage interne, application de pâte thermique, mises à jour de sécurité — pour prolonger la durée de vie de vos appareils.",

    "info.process.title": "Notre processus",
    "info.process.step1.t": "1. Appelez ou écrivez",
    "info.process.step1.d": "Décrivez le problème — nous confirmons rapidement si nous pouvons vous aider.",
    "info.process.step2.t": "2. Diagnostic",
    "info.process.step2.d": "Nous établissons un devis clair avant toute intervention.",
    "info.process.step3.t": "3. Réparation",
    "info.process.step3.d": "Travail effectué avec soin, données protégées, transparence à chaque étape.",
    "info.process.step4.t": "4. Vérification & remise",
    "info.process.step4.d": "Tests complets, explications, garantie sur l'intervention.",

    "info.cta.title": "Un ordinateur qui traîne, un doute, une urgence ?",
    "info.cta.body": "Contactez-nous — nous répondons rapidement.",
    "services.maintenance.title": "Entretien ménager",
    "services.maintenance.tag": "Commercial · Industriel",
    "services.maintenance.desc": "Programmes d'entretien récurrents pour bureaux, commerces et bâtiments industriels. Équipes formées, produits professionnels, résultats constants.",
    "services.maintenance.f1": "Nettoyage quotidien ou hebdomadaire",
    "services.maintenance.f2": "Désinfection en profondeur",
    "services.maintenance.f3": "Entretien des planchers et vitres",
    "services.maintenance.f4": "Rapports et suivi qualité",

    "services.postconstruction.title": "Nettoyage après construction",
    "services.postconstruction.tag": "Chantiers · Rénovations",
    "services.postconstruction.desc": "De la poussière fine aux résidus de peinture, nous livrons vos espaces prêts pour la remise des clés.",
    "services.postconstruction.f1": "Dépoussiérage complet (sols, murs, plafonds)",
    "services.postconstruction.f2": "Nettoyage vitres, cadrages et quincaillerie",
    "services.postconstruction.f3": "Enlèvement des étiquettes et résidus",
    "services.postconstruction.f4": "Remise des lieux clés en main",

    "services.it.title": "Informatique",
    "services.it.tag": "Réparation · Support",
    "services.it.desc": "Diagnostic et réparation d'ordinateurs, réseaux et équipements bureautiques — un service local, humain, et rapide.",
    "services.it.f1": "Diagnostic matériel et logiciel",
    "services.it.f2": "Réparation ordinateurs et portables",
    "services.it.f3": "Installation réseau et périphériques",
    "services.it.f4": "Assistance à distance ou sur site",

    "services.learn_more": "En savoir plus",

    "gallery.eyebrow": "Portfolio",
    "gallery.title": "Le travail parle de lui-même.",
    "gallery.subtitle": "Quelques chantiers récents, résidentiels et commerciaux.",

    "about.eyebrow": "Notre histoire",
    "about.title": "Une famille. Un métier. Une parole donnée.",
    "about.p1": "Une famille dévouée, spécialisée dans le nettoyage après construction ainsi que dans l'entretien ménager commercial, industriel et résidentiel, offrant un service fiable, minutieux et adapté aux besoins de chaque client.",
    "about.p2": "Chaque contrat est traité comme s'il s'agissait de notre propre maison. C'est cette exigence qui nous distingue.",
    "about.value1.t": "Fiabilité",
    "about.value1.d": "Horaires respectés, communication claire, aucune surprise.",
    "about.value2.t": "Précision",
    "about.value2.d": "Un protocole rigoureux à chaque étape de l'intervention.",
    "about.value3.t": "Humain",
    "about.value3.d": "Des personnes réelles, joignables, qui prennent soin de vos espaces.",

    "quote.eyebrow": "Soumission gratuite",
    "quote.title": "Parlez-nous de votre projet.",
    "quote.subtitle": "Remplissez ce formulaire — nous vous répondons habituellement en moins de 24 heures ouvrables.",
    "quote.name": "Prénom et nom",
    "quote.company": "Nom d'entreprise (facultatif)",
    "quote.email": "Courriel",
    "quote.phone": "Téléphone",
    "quote.service": "Service souhaité",
    "quote.service.placeholder": "Sélectionnez un service",
    "quote.service.maintenance": "Entretien ménager",
    "quote.service.postconstruction": "Nettoyage après construction",
    "quote.service.it": "Informatique",
    "quote.service.other": "Autre",
    "quote.date": "Date souhaitée (optionnel)",
    "quote.message": "Décrivez votre projet",
    "quote.submit": "Envoyer la demande",
    "quote.sending": "Envoi en cours…",
    "quote.success.title": "Demande envoyée !",
    "quote.success.body": "Merci ! Nous vous contacterons très bientôt.",
    "quote.error": "Un problème est survenu. Veuillez réessayer ou nous appeler directement.",

    "contact.eyebrow": "Nous joindre",
    "contact.title": "Basés à Laval, à votre service partout au Québec.",
    "contact.phone": "Téléphone",
    "contact.email": "Courriel",
    "contact.area": "Zone desservie",
    "contact.area.value": "Laval · Montréal · Rive-Nord · Rive-Sud",
    "contact.hours": "Heures",
    "contact.hours.value": "Lun. – Ven. 17h30 – 21h30 · Sam. – Dim. 9h – 17h",

    "footer.tagline": "Votre bien-être est notre mission.",
    "footer.rights": "Tous droits réservés.",

    "admin.login.title": "Espace administrateur",
    "admin.login.subtitle": "Connectez-vous pour gérer les soumissions.",
    "admin.login.email": "Courriel",
    "admin.login.password": "Mot de passe",
    "admin.login.submit": "Se connecter",
    "admin.login.error": "Identifiants invalides.",
    "admin.dashboard.title": "Tableau de bord",
    "admin.dashboard.logout": "Déconnexion",
    "admin.dashboard.filter.all": "Toutes",
    "admin.dashboard.filter.new": "Nouvelles",
    "admin.dashboard.filter.contacted": "Contactées",
    "admin.dashboard.filter.archived": "Archivées",
    "admin.dashboard.empty": "Aucune soumission pour ce filtre.",
    "admin.status.new": "Nouvelle",
    "admin.status.contacted": "Contactée",
    "admin.status.archived": "Archivée",
    "admin.action.mark_contacted": "Marquer contactée",
    "admin.action.archive": "Archiver",
    "admin.action.reopen": "Rouvrir",
    "admin.action.delete": "Supprimer",
    "admin.confirm.delete": "Supprimer définitivement cette soumission ?",
  },
  en: {
    "nav.home": "Home",
    "nav.services": "Services",
    "nav.gallery": "Gallery",
    "nav.about": "About",
    "nav.contact": "Contact",
    "nav.quote": "Get a quote",
    "nav.admin": "Admin",

    "hero.eyebrow": "Family-owned · Laval, Quebec",
    "hero.title.a": "Custom cleaning,",
    "hero.title.b": "delivered with",
    "hero.title.c": "genuine care.",
    "hero.subtitle": "A devoted family specialised in post-construction cleaning as well as commercial and industrial maintenance.",
    "hero.cta_primary": "Request a quote",
    "hero.cta_secondary": "See our services",

    "marquee": "Commercial maintenance · Post-construction cleaning · IT repair · Industrial service · Laval · Montreal · North Shore · South Shore",

    "services.eyebrow": "Our services",
    "services.title": "Our services",

    // Maintenance detail page
    "maint.hero.eyebrow": "Service — Maintenance",
    "maint.hero.title": "Maintenance",
    "maint.hero.subtitle": "Three worlds, one standard: industrial, commercial, and residential.",
    "maint.types.title": "Different types of maintenance",

    "maint.industriel.title": "Industrial",
    "maint.industriel.f1": "Cleaning of warehouses and factories",
    "maint.industriel.f2": "Surface and floor cleaning",
    "maint.industriel.f3": "Common areas and washrooms upkeep",
    "maint.industriel.f4": "Complementary service: post-construction cleaning",
    "maint.industriel.f5": "Waste removal",
    "maint.industriel.goal": "Goal: improve hygiene and staff productivity.",

    "maint.commercial.title": "Commercial",
    "maint.commercial.f1": "Office and workspace cleaning",
    "maint.commercial.f2": "Disinfection of high-touch surfaces",
    "maint.commercial.f3": "Toilets upkeep",
    "maint.commercial.f4": "Floor care (sweeping, washing)",
    "maint.commercial.f5": "Waste removal",
    "maint.commercial.goal": "Result: an impeccable professional image and a healthy daily space.",

    "maint.residentiel.title": "Residential",
    "maint.residentiel.f1": "General room cleaning",
    "maint.residentiel.f2": "Bathroom upkeep",
    "maint.residentiel.f3": "Dusting and surface washing",
    "maint.residentiel.f4": "Floor cleaning",
    "maint.residentiel.f5": "One-time services",
    "maint.residentiel.f6": "Complementary services: move-in / move-out cleaning, window and glass washing",
    "maint.residentiel.goal": "Benefit: more time for you, in a clean and comfortable environment.",

    "maint.plans.title": "Our subscriptions",
    "maint.plans.subtitle": "Some maintenance types work with subscriptions. This determines the number of visits per week and what can be included.",
    "maint.plans.per_week": "Visits / week",
    "maint.plans.includes": "Included",

    "maint.plans.silver.name": "SILVER",
    "maint.plans.silver.freq": "1",
    "maint.plans.silver.inc": "Basic cleaning, product not provided.",

    "maint.plans.gold.name": "GOLD",
    "maint.plans.gold.freq": "2",
    "maint.plans.gold.inc": "Cleaning with natural product provided (broom, mop, trash emptying, toilets).",

    "maint.plans.premium.name": "PREMIUM",
    "maint.plans.premium.freq": "3",
    "maint.plans.premium.inc": "Full cleaning — personalised + natural products provided (fresheners, soaps, trash bags).",

    "maint.details.title": "Service details",
    "maint.details.subtitle": "Additional services available à la carte.",
    "maint.details.item1.title": "Move-in / move-out",
    "maint.details.item1.desc": "Complete cleaning before arrival or after departure — floors, kitchens, bathrooms, full dust removal.",
    "maint.details.item2.title": "Window & glass washing",
    "maint.details.item2.desc": "Interior and exterior cleaning of accessible windows and glass, accessible frames and sills. Residential and commercial. We only work on accessible windows.",
    "maint.details.item3.title": "Post-construction cleaning",
    "maint.details.item3.desc": "Full surface cleaning and deep dust removal — floors, walls, mouldings. Removal of the fine dust left by the work, for an impeccable handover.",

    // Informatique detail page
    "info.hero.eyebrow": "Service — IT & Computing",
    "info.hero.title": "IT & Computing",
    "info.hero.subtitle": "Diagnostics, repair and support for your computers, laptops, networks and peripherals. A human, precise, local service.",

    "info.pillars.title": "What we do",
    "info.pillar1.title": "Full diagnostics",
    "info.pillar1.desc": "Hardware and software analysis, clear problem identification, and transparent estimate before any repair.",
    "info.pillar2.title": "Hardware repair",
    "info.pillar2.desc": "Screen, keyboard, battery, HDD, SSD, fan, PSU and internal component replacement.",
    "info.pillar3.title": "Optimisation & software",
    "info.pillar3.desc": "OS installation, virus/malware cleanup, backup and data recovery.",
    "info.pillar4.title": "Installation & network",
    "info.pillar4.desc": "Wi-Fi setup, printers, peripherals, small home or office network deployment.",
    "info.pillar5.title": "Remote or on-site support",
    "info.pillar5.desc": "Fast remote assistance when possible, on-site visits across Laval and Greater Montreal when needed.",
    "info.pillar6.title": "Preventive maintenance",
    "info.pillar6.desc": "Internal dust removal, fresh thermal paste, security updates — to extend the life of your devices.",

    "info.process.title": "Our process",
    "info.process.step1.t": "1. Call or write",
    "info.process.step1.d": "Describe the issue — we quickly confirm whether we can help.",
    "info.process.step2.t": "2. Diagnostic",
    "info.process.step2.d": "We provide a clear quote before any intervention.",
    "info.process.step3.t": "3. Repair",
    "info.process.step3.d": "Careful work, protected data, transparency at each step.",
    "info.process.step4.t": "4. Check & handover",
    "info.process.step4.d": "Full tests, explanations, warranty on the intervention.",

    "info.cta.title": "A sluggish computer, a doubt, an emergency?",
    "info.cta.body": "Contact us — we respond quickly.",
    "services.maintenance.title": "Cleaning & Maintenance",
    "services.maintenance.tag": "Commercial · Industrial",
    "services.maintenance.desc": "Recurring maintenance programs for offices, retail, and industrial buildings. Trained crews, professional products, consistent results.",
    "services.maintenance.f1": "Daily or weekly cleaning",
    "services.maintenance.f2": "Deep disinfection",
    "services.maintenance.f3": "Floor and window care",
    "services.maintenance.f4": "Quality reports and follow-up",

    "services.postconstruction.title": "Post-construction cleaning",
    "services.postconstruction.tag": "Jobsites · Renovations",
    "services.postconstruction.desc": "From fine dust to paint residue, we deliver spaces that are handover-ready.",
    "services.postconstruction.f1": "Full dust removal (floors, walls, ceilings)",
    "services.postconstruction.f2": "Window, trim, and hardware cleaning",
    "services.postconstruction.f3": "Sticker & residue removal",
    "services.postconstruction.f4": "Turnkey handover",

    "services.it.title": "IT & Computing",
    "services.it.tag": "Repair · Support",
    "services.it.desc": "Diagnostic and repair of computers, networks, and office equipment — local, human, fast.",
    "services.it.f1": "Hardware and software diagnostics",
    "services.it.f2": "Desktop and laptop repair",
    "services.it.f3": "Network and peripheral setup",
    "services.it.f4": "Remote or on-site assistance",

    "services.learn_more": "Learn more",

    "gallery.eyebrow": "Portfolio",
    "gallery.title": "The work speaks for itself.",
    "gallery.subtitle": "A few recent projects, residential and commercial.",

    "about.eyebrow": "Our story",
    "about.title": "One family. One craft. Our word.",
    "about.p1": "A devoted family specialised in post-construction cleaning as well as commercial, industrial and residential maintenance, offering a reliable, meticulous service tailored to every client's needs.",
    "about.p2": "Every contract is treated as if it were our own home. That is the standard that sets us apart.",
    "about.value1.t": "Reliable",
    "about.value1.d": "On time, clear communication, no surprises.",
    "about.value2.t": "Precise",
    "about.value2.d": "A rigorous protocol at every step.",
    "about.value3.t": "Human",
    "about.value3.d": "Real people, easy to reach, who care for your spaces.",

    "quote.eyebrow": "Free quote",
    "quote.title": "Tell us about your project.",
    "quote.subtitle": "Fill in this form — we usually reply within 24 business hours.",
    "quote.name": "First & last name",
    "quote.company": "Company name (optional)",
    "quote.email": "Email",
    "quote.phone": "Phone",
    "quote.service": "Service needed",
    "quote.service.placeholder": "Select a service",
    "quote.service.maintenance": "Cleaning & maintenance",
    "quote.service.postconstruction": "Post-construction cleaning",
    "quote.service.it": "IT & computing",
    "quote.service.other": "Other",
    "quote.date": "Preferred date (optional)",
    "quote.message": "Describe your project",
    "quote.submit": "Send request",
    "quote.sending": "Sending…",
    "quote.success.title": "Request sent!",
    "quote.success.body": "Thanks! We will get back to you very soon.",
    "quote.error": "Something went wrong. Please try again or call us directly.",

    "contact.eyebrow": "Reach us",
    "contact.title": "Based in Laval, serving all of Quebec.",
    "contact.phone": "Phone",
    "contact.email": "Email",
    "contact.area": "Service area",
    "contact.area.value": "Laval · Montreal · North Shore · South Shore",
    "contact.hours": "Hours",
    "contact.hours.value": "Mon – Fri 5:30pm – 9:30pm · Sat – Sun 9am – 5pm",

    "footer.tagline": "Your well-being is our mission.",
    "footer.rights": "All rights reserved.",

    "admin.login.title": "Admin area",
    "admin.login.subtitle": "Sign in to manage quote requests.",
    "admin.login.email": "Email",
    "admin.login.password": "Password",
    "admin.login.submit": "Sign in",
    "admin.login.error": "Invalid credentials.",
    "admin.dashboard.title": "Dashboard",
    "admin.dashboard.logout": "Sign out",
    "admin.dashboard.filter.all": "All",
    "admin.dashboard.filter.new": "New",
    "admin.dashboard.filter.contacted": "Contacted",
    "admin.dashboard.filter.archived": "Archived",
    "admin.dashboard.empty": "No quote for this filter.",
    "admin.status.new": "New",
    "admin.status.contacted": "Contacted",
    "admin.status.archived": "Archived",
    "admin.action.mark_contacted": "Mark contacted",
    "admin.action.archive": "Archive",
    "admin.action.reopen": "Reopen",
    "admin.action.delete": "Delete",
    "admin.confirm.delete": "Permanently delete this quote?",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("gsm_lang") || "fr");
  useEffect(() => {
    localStorage.setItem("gsm_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = (key) => TRANSLATIONS[lang]?.[key] || TRANSLATIONS.fr[key] || key;
  const toggleLang = () => setLang((l) => (l === "fr" ? "en" : "fr"));
  return (
    <I18nContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
